import React, { useId } from "react";
import classNames from "classnames";
import includes from "lodash/includes";
import { TooltipTemplate } from "UiKit";
import locale from "Areas/Sidebar/Documents/tabTasks/tasks.inner/task/task.locale";
function TaskShowButton({ item, ...props }) {
    const showEyeId = useId();
    return (React.createElement("div", null,
        React.createElement("i", { className: classNames("ml-0_5 pl-0_25 pr-0_25 line-height-1 clickable animate-hover-color text-default", !includes(props.showedResultsSourceTaskIds, item.Id) ? "icon-eye-slash" : "icon-eye"), onClick: () => {
                var _a;
                ((_a = props.data.Document) === null || _a === void 0 ? void 0 : _a.Id) &&
                    props.onToggleShowHideResults &&
                    props.onToggleShowHideResults(props.data.Document.Id, [item.Id], !includes(props.showedResultsSourceTaskIds, item.Id));
            }, id: showEyeId }),
        React.createElement(TooltipTemplate, { id: showEyeId, position: "top" },
            React.createElement("span", null, !includes(props.showedResultsSourceTaskIds, item.Id)
                ? locale.TOOLTIP_HIDE_OBJECTS_COUNT
                : locale.TOOLTIP_SHOW_OBJECTS_COUNT))));
}
export default TaskShowButton;
